import { PostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useAppPathname, useAppSearchParams } from '@/routing';
import { env } from '@/platform/env';

const posthogKey = env.posthogKey || 'phc_XiTwzDtJBPR3zmGmn4LpUTOMAFWwjklQV1RrhvFAgfK';
const posthogHost = env.posthogHost;
const isPostHogEnabled = () => {
  if (typeof window === 'undefined' || !posthogKey) return false;

  const isDevelopment = process.env.NODE_ENV === 'development';
  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('localhost');

  return !isDevelopment && !isLocalhost;
};

if (typeof window !== 'undefined') {
  if (isPostHogEnabled()) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      capture_pageview: false,
      capture_pageleave: true,
      person_profiles: 'identified_only',
      defaults: '2025-05-24',
      loaded: posthog => {
        console.log('PostHog loaded in production');
      }
    });
  }
}

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

function PostHogPageViewInner(): React.JSX.Element {
  const pathname = useAppPathname();
  const searchParams = useAppSearchParams();
  const queryString = searchParams.toString();

  useEffect(() => {
    if (typeof window !== 'undefined' && posthog?.__loaded) {
      const url = `${window.location.origin}${pathname}${queryString ? `?${queryString}` : ''}`;

      posthog.capture('$pageview', {
        $current_url: url
      });
    }
  }, [pathname, queryString]);

  return <></>;
}

export function PostHogPageView(): React.JSX.Element {
  return <PostHogPageViewInner />;
}
